import { ProductTypeEnum } from '../enums/product-capture.enums';
import { DropDownOption } from '../interfaces/drop-down-option.interface';

export enum UPSIDE_TYPE_KEYS {
  CALL = 'CALL',
  KNOCK_OUT_CALL = 'KNOCK_OUT_CALL',
  TWIN_WIN = 'TWIN_WIN',
  KNOCK_OUT_TWIN_WIN = 'KNOCK_OUT_TWIN_WIN',
  DIGITAL = 'DIGITAL',
  CALL_WARRANT = 'CALL_WARRANT',
  PUT_WARRANT = 'PUT_WARRANT',
  CALL_DISCOUNT = 'CALL_DISCOUNT',
  PUT_DISCOUNT = 'PUT_DISCOUNT',
  KNOCK_OUT_CALL_WAVE = 'KNOCK_OUT_CALL_WAVE',
  KNOCK_OUT_PUT_WAVE = 'KNOCK_OUT_PUT_WAVE',
  KNOCK_OUT_CALL_WAVE_UNLIMITED = 'KNOCK_OUT_CALL_WAVE_UNLIMITED',
  KNOCK_OUT_PUT_WAVE_UNLIMITED = 'KNOCK_OUT_PUT_WAVE_UNLIMITED',
  KNOCK_OUT_CALL_WAVE_XXL = 'KNOCK_OUT_CALL_WAVE_XXL',
  KNOCK_OUT_PUT_WAVE_XXL = 'KNOCK_OUT_PUT_WAVE_XXL',
  KNOCK_IN_DIGITAL_CALL = 'KNOCK_IN_DIGITAL_CALL',
  KNOCK_IN_DIGITAL_PUT = 'KNOCK_IN_DIGITAL_PUT',
  KNOCK_OUT_CALL_BARRIER = 'KNOCK_OUT_CALL_BARRIER',
  KNOCK_OUT_PUT_BARRIER = 'KNOCK_OUT_PUT_BARRIER',
  KNOCK_OUT_DIGITAL_CALL = 'KNOCK_OUT_DIGITAL_CALL',
  KNOCK_OUT_DIGITAL_PUT = 'KNOCK_OUT_DIGITAL_PUT',
  KNOCK_OUT_FIXED_KNOCK_IN_CALL = 'KNOCK_OUT_FIXED_KNOCK_IN_CALL',
  KNOCK_OUT_FIXED_KNOCK_IN_PUT = 'KNOCK_OUT_FIXED_KNOCK_IN_PUT',
  KNOCK_OUT_DIGITAL_CALL_WINDOW = 'KNOCK_OUT_DIGITAL_CALL_WINDOW',
  KNOCK_OUT_DIGITAL_PUT_WINDOW = 'KNOCK_OUT_DIGITAL_PUT_WINDOW',
  KNOCK_OUT_DIGITAL_CORRIDOR = 'KNOCK_OUT_DIGITAL_CORRIDOR',
  KNOCK_OUT_FIXED_KNOCK_IN_STRADDLE = 'KNOCK_OUT_FIXED_KNOCK_IN_STRADDLE',
  KNOCK_OUT_DIGITAL_CORRIDOR_WINDOW = 'KNOCK_OUT_DIGITAL_CORRIDOR_WINDOW',
  DIGITAL_CALL = 'DIGITAL_CALL',
  DIGITAL_PUT = 'DIGITAL_PUT',
  KNOCK_OUT_CALL_BARRIER_PLUS = 'KNOCK_OUT_CALL_BARRIER_PLUS',
  KNOCK_OUT_PUT_BARRIER_PLUS = 'KNOCK_OUT_PUT_BARRIER_PLUS',
}

export const UPSIDE_TYPE_ITEMS = [
  { id: 'NONE', displayValue: 'None' },
  { id: UPSIDE_TYPE_KEYS.CALL, displayValue: 'Call' },
  { id: UPSIDE_TYPE_KEYS.KNOCK_OUT_CALL, displayValue: 'Knock Out Call' },
  { id: UPSIDE_TYPE_KEYS.TWIN_WIN, displayValue: 'Twin Win' },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_TWIN_WIN,
    displayValue: 'Knock Out Twin Win',
  },
  { id: UPSIDE_TYPE_KEYS.DIGITAL, displayValue: 'Digital' },
  { id: UPSIDE_TYPE_KEYS.CALL_WARRANT, displayValue: 'Call Warrant' },
  { id: UPSIDE_TYPE_KEYS.PUT_WARRANT, displayValue: 'Put Warrant' },
  {
    id: UPSIDE_TYPE_KEYS.CALL_DISCOUNT,
    displayValue: 'Discount Call Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.PUT_DISCOUNT,
    displayValue: 'Discount Put Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_CALL_WAVE,
    displayValue: 'WAVE (Knock Out) Call Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_PUT_WAVE,
    displayValue: 'WAVE (Knock Out) Put Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_CALL_WAVE_UNLIMITED,
    displayValue: 'Wave Unlimited (Knock Out Perpetual) Call Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_PUT_WAVE_UNLIMITED,
    displayValue: 'Wave Unlimited (Knock Out Perpetual) Put Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_CALL_WAVE_XXL,
    displayValue: 'Wave XXL (Knock Out Perpetual) Call Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_PUT_WAVE_XXL,
    displayValue: 'Wave XXL (Knock Out Perpetual) Put Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_IN_DIGITAL_CALL,
    displayValue: 'One Touch Single Barrier Call Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_IN_DIGITAL_PUT,
    displayValue: 'One Touch Single Barrier Put Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_CALL_BARRIER,
    displayValue: 'Barrier One Touch Plus Call Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_PUT_BARRIER,
    displayValue: 'Barrier One Touch Plus Put Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_DIGITAL_CALL,
    displayValue: 'No Touch Single Barrier Call Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_DIGITAL_PUT,
    displayValue: 'No Touch Single Barrier Put Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_FIXED_KNOCK_IN_CALL,
    displayValue: 'Barrier Plus (StayHigh Plus) Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_FIXED_KNOCK_IN_PUT,
    displayValue: 'Barrier Plus (StayLow Plus) Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_DIGITAL_CALL_WINDOW,
    displayValue: 'Window No Touch Single Barrier Call Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_DIGITAL_PUT_WINDOW,
    displayValue: 'Window No Touch Single Barrier Put Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_DIGITAL_CORRIDOR,
    displayValue: 'Inline Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_FIXED_KNOCK_IN_STRADDLE,
    displayValue: 'Dual Barrier Range Plus (Corridor Plus) Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_DIGITAL_CORRIDOR_WINDOW,
    displayValue: 'Window Inline Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.DIGITAL_CALL,
    displayValue: 'Digital Call Warrant',
  },
  { id: UPSIDE_TYPE_KEYS.DIGITAL_PUT, displayValue: 'Digital Put Warrant' },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_CALL_BARRIER_PLUS,
    displayValue: 'Barrier Plus (EndHigh) Call Warrant',
  },
  {
    id: UPSIDE_TYPE_KEYS.KNOCK_OUT_PUT_BARRIER_PLUS,
    displayValue: 'Barrier Plus (EndLow) Put Warrant',
  },
];

export const filterUpsideOptions = (options: any[]): DropDownOption[] =>
  UPSIDE_TYPE_ITEMS.filter((opts: DropDownOption) => options.includes(opts.id));

const PARTICIPATION_SUPERTRACKER_OPTIONS = filterUpsideOptions([
  'CALL',
  'KNOCK_OUT_CALL',
  'DIGITAL',
]);

const PARTICIPATION_WARRANT_OPTIONS = filterUpsideOptions([
  UPSIDE_TYPE_KEYS.CALL_WARRANT,
  UPSIDE_TYPE_KEYS.PUT_WARRANT,
  UPSIDE_TYPE_KEYS.CALL_DISCOUNT,
  UPSIDE_TYPE_KEYS.PUT_DISCOUNT,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_CALL_WAVE,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_PUT_WAVE,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_CALL_WAVE_UNLIMITED,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_PUT_WAVE_UNLIMITED,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_CALL_WAVE_XXL,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_PUT_WAVE_XXL,
  UPSIDE_TYPE_KEYS.KNOCK_IN_DIGITAL_CALL,
  UPSIDE_TYPE_KEYS.KNOCK_IN_DIGITAL_PUT,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_CALL_BARRIER,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_PUT_BARRIER,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_DIGITAL_CALL,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_DIGITAL_PUT,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_FIXED_KNOCK_IN_CALL,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_FIXED_KNOCK_IN_PUT,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_DIGITAL_CALL_WINDOW,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_DIGITAL_PUT_WINDOW,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_DIGITAL_CORRIDOR,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_FIXED_KNOCK_IN_STRADDLE,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_DIGITAL_CORRIDOR_WINDOW,
  UPSIDE_TYPE_KEYS.DIGITAL_CALL,
  UPSIDE_TYPE_KEYS.DIGITAL_PUT,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_CALL_BARRIER_PLUS,
  UPSIDE_TYPE_KEYS.KNOCK_OUT_PUT_BARRIER_PLUS,
]);

export const PRODUCT_UPSIDE_TYPES = new Map<ProductTypeEnum, DropDownOption[]>([
  [
    ProductTypeEnum.AUTOCALL_GROWTH_AT_MATURITY,
    filterUpsideOptions(['CALL', 'KNOCK_OUT_CALL', 'PUT']),
  ],
  [ProductTypeEnum.PARTICIPATION_NOTE, PARTICIPATION_SUPERTRACKER_OPTIONS],
  [ProductTypeEnum.SUPERTRACKER, PARTICIPATION_SUPERTRACKER_OPTIONS],
  [
    ProductTypeEnum.PERFORMANCE_LINKED_COUPON,
    PARTICIPATION_SUPERTRACKER_OPTIONS,
  ],
  [ProductTypeEnum.WARRANT, PARTICIPATION_WARRANT_OPTIONS],
]);
